import React from 'react';
import PropTypes from 'prop-types';
import { alpha, useTheme } from '@material-ui/core';
import Box from '@material-ui/core/Box';
import { getCherrySoftwareIcon } from '../cherrySoftwareIcons';

const FloatingDecor = ({ icons = [], sx = {} }) => {
  const theme = useTheme();

  return (
    <Box sx={{ position: 'absolute', inset: 0, pointerEvents: 'none', overflow: 'hidden', ...sx }}>
      {icons.map((item) => {
        const Icon = getCherrySoftwareIcon(item.icon);
        return (
          <Box
            key={item.id}
            sx={{
              position: 'absolute',
              top: item.top,
              left: item.left,
              right: item.right,
              bottom: item.bottom,
              width: item.size,
              height: item.size,
              borderRadius: item.rounded || '16px',
              display: 'grid',
              placeItems: 'center',
              bgcolor: alpha(theme.palette[item.color || 'primary'].main, item.opacity || 0.1),
              border: `1px solid ${alpha(theme.palette[item.color || 'primary'].main, 0.16)}`,
              color: theme.palette[item.color || 'primary'].main,
              animation: item.animate ? 'cd-float 6s ease-in-out infinite' : 'none',
              animationDelay: item.delay || '0s',
              '@keyframes cd-float': {
                '0%, 100%': { transform: 'translateY(0px)' },
                '50%': { transform: 'translateY(-10px)' },
              },
              '& svg': { fontSize: Math.round(item.size * 0.45) },
            }}
          >
            <Icon />
          </Box>
        );
      })}
    </Box>
  );
};

FloatingDecor.propTypes = {
  icons: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      icon: PropTypes.string.isRequired,
      top: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      left: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      right: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      bottom: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      size: PropTypes.number,
      color: PropTypes.string,
      opacity: PropTypes.number,
      rounded: PropTypes.string,
      animate: PropTypes.bool,
      delay: PropTypes.string,
    }),
  ),
  sx: PropTypes.object,
};

export default FloatingDecor;
